import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaymentSplitting } from './type';
import { Observable } from 'rxjs';
import { ErrorService } from '../../error';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PaymentSplittingApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService
  ) {}

  getById = (id: string): Observable<PaymentSplitting> => {
    let parameters: string[];
    parameters = [id];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<PaymentSplitting>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };

  getByProductLine = (productLine: string): Observable<PaymentSplitting[]> => {
    let parameters: string[];
    parameters = ['ProductLine', encodeURI(productLine)];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<PaymentSplitting[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };

  getByInsuranceCompanyId = (
    insuranceCompanyId: number
  ): Observable<PaymentSplitting[]> => {
    let parameters: string[];
    parameters = ['InsuranceCompany', insuranceCompanyId.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<PaymentSplitting[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      })
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.paymentsplittings.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
